export default __webpack_public_path__ + "static/media/banner_3.225c7241.png";